
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/network/my-circle/third",
      function () {
        return require("private-next-pages/profile/network/my-circle/third/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/network/my-circle/third"])
      });
    }
  